<template>
  <account-modal class="t-master-account-form-modal">
    <template slot="heading">
      <div>{{ headingText }}</div>
    </template>

    <template slot="content">
      <one-data-column :label-props="{ style: 'display: none;' }">
        <v-layout row>
          <v-flex xs10>
            <account-select
              v-model="form.feeAccountId"
              class="t-fee-account-field"
              label="Fee account"
              hint="Required field"
              show-name
              regular
              :accounts="feeAccountOptions"
            />
          </v-flex>
        </v-layout>
      </one-data-column>
      <error-alert :error="error" />
    </template>

    <template slot="actions">
      <v-btn
        color="light-blue darken-3"
        flat
        :disabled="!isFormFilled || loading"
        @click="onSaveButtonClick"
      >save</v-btn>

      <v-btn
        color="light-blue darken-3"
        flat
        @click="onCancelButtonClick"
      >cancel</v-btn>
    </template>
  </account-modal>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Events
  import { EVENT_ACCOUNT_UPDATE } from '@/events/accounts'
  import { EVENT_PROFILE_UPDATE } from '@/events/profiles'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import AccountApi from '@/services/Api/AccountApi'

  // Mixins
  import form from '@/mixins/form'

  // Component
  import AccountModal from '@/components/accounts/AccountModal'
  import AccountSelect from '@/components/ui/AccountSelect'
  import ErrorAlert from '@/components/ui/ErrorAlert'
  import OneDataColumn from '@/components/ui/Data/OneDataColumn'

  export default {
    name: 'MasterAccountFormModal',
    components: {
      AccountModal,
      AccountSelect,
      ErrorAlert,
      OneDataColumn
    },
    mixins: [form],
    data () {
      return {
        accountUseAsMasterApiRequest: new ApiRequest(AccountApi.useAsMaster),
        form: {
          feeAccountId: null
        },
        requiredFields: ['feeAccountId']
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      profileId () {
        return this.modal.data.userId
      },
      account () {
        return this.modal.data.account
      },
      loading () {
        return this.accountUseAsMasterApiRequest.loading
      },
      error () {
        return this.accountUseAsMasterApiRequest.error
      },
      feeAccountOptions () {
        return this.modal.data.accounts.filter((account) => {
          return account.accountId !== this.account.accountId && !account.isUsedAsMaster && !account.isRecurringFeeFree
        })
      },
      defaultHeading () {
        const { accountId, hasName, name } = this.account

        return `Use account ${accountId}${hasName ? ` "${name}"` : ''} as master?`
      },
      headingText () {
        return this.modal.data.heading ?? this.defaultHeading
      },
      successMessage () {
        return this.modal.data.successMessage ?? 'Account has been successfully set as master.'
      }
    },
    created () {
      if (this.modal.data.account.feeWalletId) {
        this.form.feeAccountId = this.modal.data.account.feeWalletId
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onSaveButtonClick () {
        this.accountUseAsMasterApiRequest
          .execute(this.account.accountId, this.form.feeAccountId)
          .then(this.accountUseAsMasterSuccessHandler)
          .catch(() => {})
      },
      onCancelButtonClick () {
        this.closeModal()
      },
      accountUseAsMasterSuccessHandler () {
        const successMessage = this.successMessage
        this.$eventHub.$emit(EVENT_ACCOUNT_UPDATE, this.profileId)
        this.$eventHub.$emit(EVENT_PROFILE_UPDATE)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: successMessage }
          })
        }, 100)
      }
    }
  }
</script>
